/* RFC 4180 style CSV parser operating on the whole document instead of
   line-by-line, so quoted fields may contain delimiters, escaped quotes ("")
   and embedded newlines (e.g. multi-line addresses in Bolt invoices) */
export const parseCSV = (
  text: string,
  delimiters: string[] = [',', ';']
): string[][] => {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;

  const pushField = () => {
    row.push(field.trim());
    field = '';
  };

  const pushRow = () => {
    pushField();
    if (row.some(value => value !== '')) rows.push(row);
    row = [];
  };

  const chars = text.startsWith('\ufeff') ? text.slice(1) : text;

  for (let i = 0; i < chars.length; i++) {
    const char = chars[i];

    if (char === '"') {
      if (inQuotes && chars[i + 1] === '"') {
        field += '"';
        i++;
        continue;
      }

      inQuotes = !inQuotes;
      continue;
    }

    if (!inQuotes) {
      if (delimiters.includes(char)) {
        pushField();
        continue;
      }

      if (char === '\n' || char === '\r') {
        if (char === '\r' && chars[i + 1] === '\n') i++;
        pushRow();
        continue;
      }
    }

    field += char;
  }

  if (field !== '' || row.length > 0) pushRow();

  return rows;
};
